export default __webpack_public_path__ + "_/images/referrals/devices_mobile-adb43e6fa4ce771becb9689e2508aadd8ff3c9005b9f8502d23b22e0a1bf7b0c.png";